<template>
<div class="mdl-layout mdl-js-layout mdl-layout--fixed-header">
  <header class="mdl-layout__header">
    <div class="mdl-layout__header-row">
      <!-- Title -->
      <span class="mdl-layout-title">
        <mdl-select label="Dzień" id="slug-select" :value="slug" @input="goToDay" :options="days"></mdl-select>
      </span>
      <!-- Add spacer, to align navigation to the right -->
      <div class="mdl-layout-spacer"></div>
      <!-- Navigation. We hide it in small screens. -->
      <nav class="mdl-navigation">
        <button
          v-if="card && thereAreChangedRecordsFor(card)"
          class="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--accent"
          :disabled="offline || updating"
          @click="updateCard(card)"
        >
          <template v-if="offline">offline</template>
          <template v-else>
            <template v-if="updating">wysyłam... <mdl-spinner single-color></mdl-spinner></template>
            <template v-else>Wyślij</template>
          </template>
        </button>
      </nav>
    </div>
  </header>
  <div class="mdl-layout__drawer">
    <span class="mdl-layout-title">
      <a href="" @click.prevent="hideMenu" style="float: right; margin-right: 20px;">
        <i class="material-icons">arrow_back</i>
      </a>
    </span>
    <form action="#">
      <div style="width: 90%; margin: 0 auto; position: relative">
        <input class="mdl-textfield__input"
               type="text"
               v-model="search"
               id="sample1"
               style="padding: 5px;"
               placeholder="Szukaj..."
               v-focus="searchFocus"
               @focus="searchFocus = true"
               @blur="searchFocus = false"
        >
        <a
          href=""
          @click.prevent="clearSearch"
          style="position: absolute; right: 2px; top: 2px;"
          v-show="search"
        >
          <i class="material-icons">close</i>
        </a>
      </div>
    </form>
    <nav class="mdl-navigation" v-if="card">
      <router-link
        class="mdl-navigation__link"
        :to="getRouteToEdit(record)"
        v-for="record in filteredCardRecords"
        @click.native="hideMenu"
        :key="record.id"
      >
        <strong>
          <i v-if="record.changed" class="material-icons" style="color: #8bc34a">edit</i>
          {{ record.product.name }}
        </strong>
        <br>
        <template v-if="record.product.variety">{{ record.product.variety }},</template>
        {{ record.product.origin }},
        {{ record.product.unit }}
      </router-link>
    </nav>
    <my-spinner v-else></my-spinner>
  </div>
  <main class="mdl-layout__content">
    <div class="page-content">
      <router-view></router-view>
    </div>
  </main>
</div>
</template>

<script>
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'
import { MdlSelect, MdlSpinner } from 'vue-mdl'
import MySpinner from './MySpinner.vue'
import * as a from './../action-types'

export default {
  props: {
    slug: {type: String, required: true}
  },
  components: {
    MdlSelect,
    MdlSpinner,
    MySpinner
  },
  data () {
    return {
      search: '',
      connectionStatus: 'online',
      searchFocus: false
    }
  },
  computed: {
    ...mapGetters([
      'updating',
      'thereAreChangedRecordsFor'
    ]),
    offline () {
      return this.connectionStatus === 'offline'
    },
    filteredCardRecords () {
      return this.card.records.filter(r => r.product.name.toLowerCase().includes(this.search.toLowerCase()))
    },
    card () {
      return this.$store.getters.getCardBy(this.slug)
    },
    days () {
      let days = []
      for (let i = 0; i <= 7; i++) {
        const day = moment().locale('pl').subtract(i, 'days')
        days.push({
          name: day.format('DD-MM-YYYY (ddd)'),
          value: day.format('YYYY-MM-DD')
        })
      }
      return days
    }
  },
  methods: {
    clearSearch () {
      this.searchFocus = true
      this.search = ''
    },
    ...mapActions({
      'fetchData': a.FETCH_CARD
    }),
    updateCard (card) {
      this.$store.dispatch(a.UPDATE_CARD, card).then(
        () => {
          this.$root.$emit('flash', {message: 'Notowania zostały wysłane poprawnie'})
        },
        () => {
          this.$root.$emit('flash', {message: 'Wystąpił błąd podczas wysyłania notowań, skontaktuj się z administratorem'})
        }
      )
    },
    networkChange (e) {
      this.connectionStatus = e.type
    },
    hideMenu: function () {
      document.getElementsByClassName('mdl-layout__drawer')[0].classList.remove('is-visible')
      document.getElementsByClassName('mdl-layout__obfuscator')[0].classList.remove('is-visible')
    },
    getRouteToEdit (record) {
      return {
        name: 'RecordEdit',
        params: {
          id: record.id
        }
      }
    },
    goToDay (slug) {
      this.$router.push({
        name: 'Records',
        params: {
          slug
        }
      })
    },
    fetchWhenNeed () {
      if (!this.card) {
        this.fetchData(this.slug)
      }
    },
    goToEdit (record) {
      this.$router.push({
        name: 'RecordEdit',
        params: {
          id: record.id
        }
      })
    }
  },
  watch: {
    '$route': 'fetchWhenNeed'
  },
  created () {
    this.fetchWhenNeed()
    window.removeEventListener('online', this.networkChange)
    window.addEventListener('online', this.networkChange)
    window.removeEventListener('offline', this.networkChange)
    window.addEventListener('offline', this.networkChange)
  },
  mounted () {
    const that = this
    setTimeout(function () {
      let button = document.getElementsByClassName('mdl-layout__drawer-button')[0]
      if (button) {
        button.addEventListener('click', function () {
          that.searchFocus = true
        })
      }
    }, 100)
  }
}
</script>
<style>
.mdl-textfield {
  width: auto;
}
</style>



// WEBPACK FOOTER //
// Records.vue?77ed92c6